import React from 'react';
import { defaultBrandingColors, type PowerBrandingColors } from '@src/lib/AppContext';

interface BrandColorsProps {
  colors: PowerBrandingColors;
}

export const BrandColors = ({ colors = defaultBrandingColors }: BrandColorsProps) => {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
                :root { 
                  --power-branding-color-bg: ${colors.bg || '0, 0, 0'};
                  --power-branding-color-fg: ${colors.fg || '255, 255, 255'};
                  --power-branding-color-surface: ${colors.surface || '21, 21, 21'};
                  --power-branding-color-primary: ${colors.primary || '255, 0, 0'};
                }
                `,
      }}
    />
  );
};
